import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, of, retry, switchMap } from 'rxjs';

import { SnackBarService } from '@components/sq-snackbar/sq-snackbar.service';

import * as actions from './enums.actions';
import { EnumsService } from './enums.service';

@Injectable()
export class Effects {
  private actions$ = inject(Actions);
  private enumsService = inject(EnumsService);
  private snackBarService = inject(SnackBarService);

  fetchList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.enumsFetchListStart),
      switchMap(() => {
        return this.enumsService.fetchList().pipe(
          retry(1),
          map(payload => {
            return actions.enumsFetchListSuccess({ payload });
          }),
          catchError(() => {
            this.snackBarService.setError('Sorry, there has been an issue fetching your page');
            return of(actions.enumsFetchListFail());
          }),
        );
      }),
    ),
  );
}
